import { createAction } from 'redux-actions';

export const addPostponedAction = createAction('ADD_POSTPONED_ACTION');
export const dispatchPostponedActions = createAction('DISPATCH_POSTPONED_ACTIONS');
export const dismissPostponedActions = createAction('DISMISS_POSTPONED_ACTIONS');
